import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { ComingSoonLabelComponent } from '../components';

@Component({
  selector: 'rp-home-gift-shop-schema',
  standalone: true,
  templateUrl: './gift-shop-schema.component.html',
  styleUrl: './../schema.base.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, ComingSoonLabelComponent],
})
export class GiftShopSchemaComponent {}
